<template>
  <div
    class="navbar-mobile"
    v-if="isMobile"
    :class="{ 'fixed-element': isFixed }"
  >
    <div class="menu-header">
      <NuxtLink :to="localPath('/')" class="link-logo">
        <picture>
          <source
            media="(max-width: 1440px)"
            srcset="/images/logo-main-mobile.svg"
            width="44"
            height="28"
          />
          <img
            src="/images/logo-main-mobile.svg"
            alt="Tradeview Europe Logo, ir a inicio"
            class="logo"
            width="44"
            height="28"
          />
        </picture>
      </NuxtLink>
      <div class="secound-column">
        <LazyLanguagesModal />
        <div
          @click="toggleMenu"
          class="hamburger-icon"
          :class="{ active: isMenuOpen }"
        >
          <span
            class="material-symbols-outlined"
            translate="no"
            v-if="isMenuOpen"
            >close</span
          >
          <span
            class="material-symbols-outlined"
            translate="no"
            v-if="!isMenuOpen"
            >menu</span
          >
        </div>
      </div>
    </div>

    <div v-if="isMenuOpen" class="menu-items" ref="menuItems">
      <div
        v-for="(item, index) in navItems"
        :key="index"
        class="menu-item"
        :class="item.class"
      >
        <NuxtLink
          v-if="!item.subpages"
          :to="localPath(item.link)"
          @click="closeDropdowns"
          class="title-sub-menu"
        >
          <p>{{ $t(item.text) }}</p>
        </NuxtLink>
        <span
          v-else
          @click="toggleSubmenu(index)"
          class="title-sub-menu"
          :class="item.showSubmenu ? 'caption-bold' : ''"
          :style="item.showSubmenu ? 'color: #15202A;' : ''"
        >
          {{ $t(item.text) }}
          <span
            class="material-symbols-outlined"
            translate="no"
            :class="{ 'arrow-rotate': item.showSubmenu }"
            >expand_more</span
          >
        </span>
        <!-- first dropdown -->
        <div v-if="item.subpages && item.showSubmenu" class="sub-menu">
          <div
            v-for="(subpage, subIndex) in item.subpages.filter(
              (subpage) => !subpage.showOnlyInEnglish || locale === 'en'
            )"
            :key="subIndex"
            class="subpage"
          >
            <NuxtLink
              v-if="!subpage.subsubpage"
              :to="localPath(subpage.link)"
              :target="subpage.target"
              @click="closeDropdowns"
              class="title-sub-menu"
            >
              <p>{{ $t(subpage.text) }}</p>
            </NuxtLink>
            <span
              v-else
              @click="toggleSubmenu2(index, subIndex)"
              class="title-sub-menu"
              :class="subpage.showSubmenu2 ? 'caption-bold' : ''"
              :style="
                subpage.showSubmenu2
                  ? 'background: rgba(164, 176, 189, 0.25);'
                  : ''
              "
            >
              {{ $t(subpage.text) }}
              <span
                class="material-symbols-outlined"
                :class="{ 'arrow-rotate': subpage.showSubmenu2 }"
                >expand_more</span
              >
            </span>
            <!-- secound dropdown -->
            <div
              v-if="subpage.subsubpage && subpage.showSubmenu2"
              class="sub-menu"
            >
              <div
                v-for="(subsubpage, subsubIndex) in subpage.subsubpage"
                :key="subsubIndex"
                class="subpage"
              >
                <NuxtLink
                  :to="localPath(subsubpage.link)"
                  @click="closeDropdowns"
                  class="subsubpage"
                  :target="subsubpage.target"
                >
                  {{ $t(subsubpage.text) }}
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <!-- <NuxtLink
        :to="localPath('/forms-and-documents')"
        @click="closeDropdowns"
        class="extra-subpage"
        ><span class="material-symbols-outlined" translate="no">article</span>
        <p>{{ $t("menu.formsDocuments") }}</p></NuxtLink
      > -->

      <div class="btns">
        <a
          target="_blank"
          :href="getExternalUrl('/register/1/live-account')"
          class="primary-button-small body-4-bold"
         rel="noopener noreferrer">
          {{ $t("menu.getStarted") }}
        </a>
        <a
          target="_blank"
          :href="getExternalUrl('/login')"
          class="second-button-small body-4-bold"
         rel="noopener noreferrer">
          {{ $t("menu.singIn") }}
        </a>
        <!-- <button @click="gotToLogin" class="second-button-small body-4-bold">
          {{ $t("menu.singIn") }}
        </button> -->
      </div>

      <!-- <RegulationBar class="RegulationBar-MenuMobile" /> -->
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, onUpdated, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useExternalUrl } from "@/composables/useExternalUrl";
import { useI18n } from "vue-i18n";

import LazyLanguagesModal from "@/components/defaultLayout/LanguagesModal.vue";

import RegulationBar from "@/components/defaultLayout/RegulationBar.vue";
// import '~/assets/scss/components/navbar-mobile.scss';

const { getExternalUrl } = useExternalUrl();
const { locale } = useI18n();

const localPath = useLocalePath();
const isMenuOpen = ref(false);
const isFixed = ref(false);
const isMobile = ref(false);
const navItems = ref([
  {
    text: "menu.markets",
    class: "markets",
    subpages: [
      {
        text: "menu.markets",
        link: "/trading/markets",
        class: "body-4-bold",
      },
      {
        text: "menu.forex",
        link: "/trading/markets/forex",
        class: "body-4",
      },
      {
        text: "menu.stocks",
        link: "/trading/markets/stocks",
        class: "body-4",
      },
      /* {
        text: "menu.futures",
        link: "/trading/markets/futures",
        class: "body-4",
      }, */
      {
        text: "menu.commodities",
        link: "/trading/markets/commodities",
        class: "body-4",
      },
      {
        text: "menu.indices",
        link: "/trading/markets/indices",
        class: "body-4",
      },
    ],
  },
  {
    text: "menu.platforms",
    class: "platforms",
    subpages: [
      {
        text: "menu.platforms",
        link: "/trading/platforms",
        class: "body-4",
      },
      /* {
        text: "menu.mt4",
        link: "/trading/platforms/metatrader4",
        class: "body-4",
      }, */
      {
        text: "menu.mt5",
        link: "/trading/platforms/metatrader5",
        class: "body-4",
      },
      /* {
        text: "menu.ctrader",
        link: "/trading/platforms/ctrader",
        class: "body-4",
      },
      {
        text: "menu.sterling2",
        link: "/trading/platforms/sterling-trader",
        class: "body-4",
      },
      {
        text: "menu.takion",
        link: "/trading/platforms/takion",
        class: "body-4",
      },
      {
        text: "menu.lightspeed",
        link: "/trading/platforms/lightspeed",
        class: "body-4",
      },
      {
        text: "menu.DAS",
        link: "/trading/platforms/das-trader",
        class: "body-4",
      },
      {
        text: "menu.cqg",
        link: "/trading/platforms/cqg-desktop",
        class: "body-4",
      }, */
    ],
  },
  {
    text: "menu.trading",
    class: "trading",
    subpages: [
      {
        text: "menu.yourTrading",
        link: "/trading",
        class: "body-4",
      },
      // {
      //   text: "menu.challenge",
      //   link: "/trading/gold-challenge",
      //   class: "body-4",
      // },

      {
        text: "menu.calculator-suite",
        link: "/trading/calculator_suite",
        class: "body-4",
      },
      {
        text: "menu.economic-calendar",
        link: "/trading/markets/trading-conditions/forex-economic-calendar/",
        class: "body-4",
      },
      {
        text: "menu.trading-eventos",
        link: "/trading/markets/trading-conditions/trading-conditions-events/",
        class: "body-4",
      },
    ],
  },
  {
    text: "menu.accounts",
    class: "accounts",
    link: "/trading/accounts",
  },
  /* {
    text: "menu.partners",
    class: "partners",
    subpages: [
      {
        text: "menu.introducing",
        link: "/partners",
        class: "body-4",
      },
      {
        text: "menu.influence",
        link: "/partners/influence-affiliates",
        class: "body-4",
      },
    ],
  }, */
  {
    text: "menu.company",
    class: "company",
    subpages: [
      {
        text: "menu.aboutUs",
        link: "/company/about-us",
      },
      /* {
        text: "menu.careers",
        link: "/company/careers",
      }, */
      /* {
        text: "menu.press",
        link: "/company/press-and-media",
      }, */
      {
        text: "menu.authorized",
        link: "/company/regulation",
      },
      /* {
        text: "menu.factsPolicy",
        link: "/company/facts-policy",
        showOnlyInEnglish: true,
        target: "_blank",
      }, */
    ],
  },
  /* {
    text: "menu.services",
    class: "services",
    subpages: [
      {
        text: "menu.services",
        link: "/services",
      },
      {
        text: "menu.communiTraders",
        link: "/services/communitraders",
      },
      {
        text: "menu.tradeGATEHub",
        link: "/services/tradegatehub-surfs-up",
      },
      {
        text: "menu.vulkanBridge",
        link: "/services/vulkan-bridge",
      },
      {
        text: "menu.MultiMAA",
        link: "/services/multimam",
      },
      {
        text: "menu.ctradercopy",
        link: "/trading/platforms/ctrader-copy",
      },
    ],
  }, */
  {
    text: "menu.formsDocuments",
    link: "/forms-and-documents",
  },
  {
    text: "menu.faq",
    link: "/faq",
  },
  {
    text: "menu.contactUs",
    link: "/contact-us",
  },
]);

const route = useRoute();
const router = useRouter();

const closeAllMenus = () => {
  isMenuOpen.value = false;
  document.body.style.overflow = ""; // Restablecer el desbordamiento del cuerpo
  navItems.value.forEach((item) => {
    item.showSubmenu = false;
    if (item.subpages) {
      item.subpages.forEach((subpage) => {
        subpage.showSubmenu2 = false;
      });
    }
  });
};

watch(
  () => route.path,
  () => {
    closeAllMenus();
  }
);

const menuItemsRef = ref(null);

const toggleSubmenu = (index) => {
  closeOtherSubmenus(index, 1);
  navItems.value[index].showSubmenu = !navItems.value[index].showSubmenu;
};

const toggleSubmenu2 = (itemIndex, subIndex) => {
  navItems.value[itemIndex].subpages[subIndex].showSubmenu2 =
    !navItems.value[itemIndex].subpages[subIndex].showSubmenu2;

  // Cerrar otros sub-submenús abiertos en el mismo submenú
  navItems.value[itemIndex].subpages.forEach((subpage, index) => {
    if (index !== subIndex) {
      subpage.showSubmenu2 = false;
    }
  });
};

const closeOtherSubmenus = (index, level) => {
  const navItemsArray = navItems.value;

  if (level === 1) {
    navItemsArray.forEach((item, itemIndex) => {
      if (itemIndex !== index && item.showSubmenu) {
        item.showSubmenu = false;
        if (item.subpages) {
          item.subpages.forEach((subpage) => {
            subpage.showSubmenu2 = false;
          });
        }
      }
    });
  } else if (level === 2) {
    const currentItem = navItemsArray[index];
    if (currentItem.subpages) {
      currentItem.subpages.forEach((subpage, subIndex) => {
        if (subIndex !== index && subpage.showSubmenu2) {
          subpage.showSubmenu2 = false;
        }
      });
    }
  }
};

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
  // Toggle body overflow
  if (isMenuOpen.value) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
};

const closeDropdowns = () => {
  isMenuOpen.value = false;
  document.body.style.overflow = ""; // Asegurar que el estilo de desbordamiento del cuerpo se restablece
  if (menuItemsRef.value) {
    navItems.value.forEach((item) => {
      if (item.showSubmenu) {
        item.showSubmenu = false;
      }
      if (item.subpages) {
        item.subpages.forEach((subpage) => {
          if (subpage.showSubmenu2) {
            subpage.showSubmenu2 = false;
          }
        });
      }
    });
  }
};

const checkIfMobile = () => {
  isMobile.value = window.innerWidth <= 1100;
};

const handleScroll = () => {
  const alturaUmbral = 50;
  let scrollY = window.scrollY;

  if (scrollY >= alturaUmbral) {
    isFixed.value = true;
  } else {
    isFixed.value = false;
  }
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  checkIfMobile();
  // Agregar un listener para detectar cambios en el tamaño de la ventana
  window.addEventListener("resize", checkIfMobile);
});

onUpdated(() => {
  if (menuItemsRef.value) {
    menuItemsRef.value.addEventListener("blur", closeDropdowns);
  }
});
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
  if (menuItemsRef.value) {
    menuItemsRef.value.removeEventListener("blur", closeDropdowns);
  }
  window.removeEventListener("resize", checkIfMobile);
});

const gotToLogin = () => {
  router.push(localPath("/cabinet/login"));
  closeDropdowns();
};
</script>
